// @index(['./!(*.spec).ts', './*/index.ts'], f => `export * from '${f.path.replace(/\/index$/, '')}';`)
export * from './recaptcha-hint';
export * from './recaptcha.component';
export * from './recaptcha.module';
// @endindex